import React from 'react';
import styled from 'styled-components';

import Icon from 'kingpin/atoms/Icon';

const MUTED = 'var(--color-text-tertiary)';

export const formatPercent = ({
  value,
  isSigned,
}: {
  value: number;
  isSigned: boolean;
}): string => {
  const rounded = Math.round(value * 10) / 10;
  const sign = isSigned && rounded > 0 ? '+' : '';
  return `${sign}${rounded.toLocaleString()}%`;
};

const Caption = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  color: ${MUTED};
  font-size: 13px;
  white-space: nowrap;
`;

// The "/ 230" after a Number's value: smaller and muted, so the value
// leads
export const RatioDenominator = styled.span`
  font-size: 0.55em;
  font-weight: 500;
  color: ${MUTED};
`;

// "60% of <label>", under a Number shown out of another metric
export const RatioCaption = ({
  ratio,
  label,
  testId,
}: {
  ratio: number;
  label: string;
  testId: string;
}) => (
  <Caption data-testid={testId}>
    <Icon icon="group" color={MUTED} width={14} height={14} />
    {formatPercent({ value: ratio, isSigned: false })} of {label}
  </Caption>
);
